import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, AppThunk } from '../app/store';
import { fetchCount } from '../api/counterAPI';
import { postRequest } from '../app/postRequest.service';
import { LoginRequest, LoginResponse } from '../interfaces/login';
import { loginApi } from '../api/loginAPI';
import { ConfigResponse } from '../interfaces/config.interface';
import { configApi } from '../api/homeAPI';

export interface ConfigState {
  value: ConfigResponse | null;
  status: 'idle' | 'loading' | 'failed';
}

const initialState: ConfigState = {
  value: null,
  status: 'idle',
};

export const configAsync = createAsyncThunk(
  'config/configAsync',
  async () => {
    const response = await configApi()
    return response.data;
  }
);

export const configSlice = createSlice({
  name: 'config',
  initialState,
  
  reducers: {
    // increment: (state) => { 
    //   state.value += 1;
    // },
    // decrement: (state) => {
    //   state.value -= 1;
    // },
    resetToInitialConfig: (state) =>{
      state.value = null;
      state.status = 'idle';
    }
    // incrementByAmount: (state, action: PayloadAction<number>) => {
    //   state.value += action.payload;
    // },
  },
  
  
  extraReducers: (builder) => {
    builder
      .addCase(configAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(configAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.value = action.payload;
      })
      .addCase(configAsync.rejected, (state) => {
        state.status = 'failed';
      });
  },
});
export const { resetToInitialConfig } = configSlice.actions;

export const { } = configSlice.actions;
export const getConfig = (state: RootState) => state.config.value;
export const isConfigLoading = (state: RootState) => state.config.status === 'loading';

export default configSlice.reducer;
